module.exports = __webpack_public_path__ + "img/feature_b02.00aec2b0.svg";